import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/ui/Button';
import Card from '@/components/ui/Card';
import Typography from '@/components/ui/Typography';

export default function PaymentSuccess() {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <Card className="w-full max-w-lg flex flex-col items-center p-8">
        <div className="mb-8 flex flex-col items-center">
          <span aria-hidden="true" style={{ fontSize: 64, marginBottom: 8 }}>
            🎉
          </span>
          <Typography variant="h1" className="mb-8" bold>
            Merci pour votre achat&nbsp;!
          </Typography>
          <Typography variant="body" className="text-neutral-700" align="center">
            {`Votre paiement a été validé. Vous avez maintenant accès à vos packs d'ateliers.`}
          </Typography>
        </div>

        <Button
          variant="primary"
          size="medium"
          onClick={() => navigate('/ateliers')}
          className="w-full"
        >
          {`Voir les ateliers`}
        </Button>
      </Card>
    </div>
  );
}
